import { Layout, PageHeader, UnvButton, UnvModal, UnvInput, EmptyState, Card, Icon } from 'components'
import { useEffect, useState } from 'react'
import styles from './AccountingPage.module.scss'

import { useDispatch, useSelector } from 'react-redux'

import { useNavigate } from 'react-router-dom'

import { PostAccounting, getAccountingData } from "service/AccountingService";
import { useTranslation } from 'react-i18next'
import userInfo from 'utils/userInfo'

const AccountingPage = () => {
  const { t } = useTranslation('common')

  const navigate = useNavigate()
  const [openModal, setOpenModal] = useState(false);
  const [body, setBody] = useState("");
  const [render, setRender] = useState(false)
  const [data, setData] = useState([]);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  const getData = async () => {
    try {
      let response = await getAccountingData(data);
      setData(response.data);

    } catch (error) {
    }
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!body) {
      setNotify({
        isOpen: true,
        message: t('accounting.fund_name_required', 'Введите наименование фонда!'),
        type: "error",
      });

    }
    else {
      const formData = new FormData();
      formData.append('name', body);


      let data = await PostAccounting(formData);

      getData();

      setBody("");
      setOpenModal(false)
      setNotify({
        isOpen: true,
        message: "Фонд успешно создан!",
        type: "success",
        sound: "success"
      });
      setRender(true)
    }

  };
  const handleClick = (id) => {
    if (typeof id !== "undefined") {

      navigate(`/accounting-info/`, { state: { usedId: id } });
    }
  };

  useEffect(() => {

    getData();

    setRender(false);


  }, [render]);
  const isEmpty = !Array.isArray(data) || data.length === 0
  return (
    <Layout>
      <PageHeader
        icon={<Icon name="dollar" size={28} />}
        title={t('auto.accountingpage.title', 'Бухгалтерия')}
        subtitle={t('auto.accountingpage_accountingpage.k1')}
        actions={
          <UnvButton variant="primary" iconLeft="plus" onClick={() => setOpenModal(true)}>
            {t('auto.accountingpage.create_fund', 'Создать фонд')}
          </UnvButton>
        }
      />
      <div className={styles.project__wrapper}>
        <div className={styles.project__body_info}>
          {isEmpty ? (
            <EmptyState
              iconName="dollar"
              title={t('auto.accountingpage.empty', 'Фондов пока нет')}
              action={<UnvButton variant="primary" iconLeft="plus" onClick={() => setOpenModal(true)}>{t('auto.accountingpage.create_fund', 'Создать фонд')}</UnvButton>}
            />
          ) : data.map((item) => (
            <Card padding="md" key={item.id} interactive>
              <Card.Body>
                <h3 style={{ marginTop: 0 }}>{item.name}</h3>
                <UnvButton variant="primary" iconRight="arrow-right" onClick={() => handleClick(item.id)}>
                  {t('auto.accountingpage.open', 'Перейти')}
                </UnvButton>
              </Card.Body>
            </Card>
          ))}
        </div>
      </div>
      <UnvModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        title={t('auto.accountingpage.fund_name', 'Введите название фонда')}
        size="sm"
      >
        <form onSubmit={handleSubmit} id="accounting-create-form">
          <UnvInput
            label={t('auto.accountingpage.fund_name', 'Введите название фонда')}
            placeholder={t('auto.accountingpage_accountingpage.k2')}
            value={body}
            name="body"
            onChange={(e) => setBody(e.target.value)}
          />
        </form>
        <UnvModal.Footer>
          <UnvButton variant="ghost" onClick={() => setOpenModal(false)}>{t('common.close')}</UnvButton>
          <UnvButton variant="primary" iconLeft="plus" type="submit" form="accounting-create-form">{t('common.create')}</UnvButton>
        </UnvModal.Footer>
      </UnvModal>
    </Layout>
  )
}

export default AccountingPage
